function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.1875 6.646C16.8416 6.646 6.83333 16.6543 6.83333 29.0002C6.83333 41.346 16.8416 51.3543 29.1875 51.3543C41.5334 51.3543 51.5417 41.346 51.5417 29.0002C51.5417 16.6543 41.5334 6.646 29.1875 6.646ZM3.20833 29.0002C3.20833 14.6523 14.8396 3.021 29.1875 3.021C43.5354 3.021 55.1667 14.6523 55.1667 29.0002C55.1667 43.3481 43.5354 54.9793 29.1875 54.9793C14.8396 54.9793 3.20833 43.3481 3.20833 29.0002Z",
  fill: "#0A161F",
  fillOpacity: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.1494 19.0912C41.9505 19.6915 42.1132 20.8275 41.5129 21.6285L28.8358 38.5452C28.5414 38.938 28.1003 39.1946 27.6134 39.2564C27.1264 39.3181 26.6353 39.1798 26.2522 38.8729L17.1793 31.6049C16.3981 30.979 16.2721 29.8384 16.8979 29.0571C17.5238 28.2759 18.6644 28.1499 19.4457 28.7757L27.0575 34.8733L38.6121 19.4547C39.2124 18.6536 40.3484 18.4909 41.1494 19.0912Z",
  fill: "#0A161F",
  fillOpacity: 0.2
});

function SvgCircledCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledCheck);
export default __webpack_public_path__ + "static/media/CircledCheck.060241f4.svg";
export { ForwardRef as ReactComponent };